<template>
    <div class="app-main goods-stock">

        
        <div class="top-bar">
            <el-input placeholder="输入条形码/商品名称筛选" v-model="value" @change="search()" style="width:210px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column prop="name"   align="center" label="商品名称"  show-overflow-tooltip  width="350"></el-table-column>
                <el-table-column prop="order_title"      align="center" label="订单号" show-overflow-tooltip width="250"></el-table-column>
                <el-table-column prop="barcode" align="center" label="条形码" width="200"></el-table-column>
                <el-table-column prop="created_at"  align="center" label="操作时间" width="200"></el-table-column>
                <el-table-column prop="executor_name"  align="center" label="操作人" width="120"></el-table-column>
                <el-table-column prop="enter_mode_title"  align="center" label="操作方式"  width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.action == 1">
                            {{scope.row.out_mode_title}}
                        </span> 
                         <span v-else>
                             {{scope.row.enter_mode_title}}
                         </span>
                    </template> 
                </el-table-column>
                <el-table-column prop="action_title"  label="操作行为" align="center" ></el-table-column>
                <el-table-column prop="number"  label="数量" align="center" ></el-table-column>
                <el-table-column prop="number_new"  label="在库数量" align="center" ></el-table-column>
                <el-table-column prop="remarks" label="备注" align="center" show-overflow-tooltip width="250"></el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size" ></el-pagination>
        </el-card>
    </div>
</template>



<script>

import { sku_stock } from '@/api/warehouse.js'

export default {
    data() {
        return {
            value:'',
            tableData:[],
            table_load:false,
            checkData:[],
            total:0,
            size:20,
            page:1,
        }
    },
    methods: {

        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            sku_stock(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
    },
    created(){
        this.getData();
        
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.goods-stock {
    .table-btns {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .el-button {
            margin-bottom: 5px;
        }
        .el-button+.el-button {
            margin-left: 0;
        }
    }
}
</style>
